import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  startEditingEvent,
  archiveEvent,
  searchTeamEvents,
  clearTeamEventsSearchResults
} from 'actions/Event';

import {} from 'actions/Team';

import EventList from 'components/event/List';
import EventSearchInput from 'components/team/EventSearchInput';
import { onSearchTermChange, onCancelSearch } from 'utils/eventSearchHelper';
import { redirectToEventDash } from 'utils/redirectHelper';
import { getDateFormat } from 'utils/teamHelper';

const TeamEventList = React.memo(props => {
  const {
    createEventButton,
    duplicateButtonAction,
    events,
    startEditingEvent,
    archiveEvent,
    history,
    searchTeamEvents,
    filter,
    clearTeamEventsSearchResults,
    teamEventSearchResults,
    team,
    isLoading
  } = props;

  const [searchTerm, setSearchTerm] = useState('');

  if (!events || !team) return <span />;

  const onItemClick = redirectToEventDash.bind(null, history);

  const eventSearchNode = (
    <EventSearchInput
      dateFormat={getDateFormat(team)}
      onChange={onSearchTermChange.bind(
        null,
        setSearchTerm,
        searchTeamEvents,
        clearTeamEventsSearchResults,
        filter
      )}
      onResultClick={onItemClick}
      onCancel={onCancelSearch.bind(
        null,
        setSearchTerm,
        clearTeamEventsSearchResults
      )}
      value={searchTerm}
      results={teamEventSearchResults}
    />
  );

  return (
    <EventList
      onEditClick={startEditingEvent}
      onViewClick={event => {
        history.push(`/dash/team/${team._id}/event/${event._id}/dashboard`);
      }}
      onDuplicateClick={duplicateButtonAction}
      onArchiveClick={archiveEvent}
      {...{ createEventButton, eventSearchNode, events, team, isLoading }}
    />
  );
});

TeamEventList.displayName = 'TeamEventList';

export default withRouter(
  connect(
    ({ teamEventSearchResults }) => {
      return { teamEventSearchResults };
    },
    {
      startEditingEvent,
      archiveEvent,
      searchTeamEvents,
      clearTeamEventsSearchResults
    }
  )(TeamEventList)
);
